export function experts() {
  let experts_slider = new Swiper(".experts-slider", {
    loop: true,
    grabCursor: true,
    spaceBetween: 40,
    effect: "fade",
    // autoplay: {
    //   delay: 4000,
    // },
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  /**
   * Function to order experts listing alphabetically
   */
  let order_experts = () => {
    /**
     * Make sure the experts listing is available
     */
    if (document.querySelector(".experts-listing .listing")) {
      /**
       * Get all visible boxes
       */
      let list = document.querySelector(".experts-listing .listing");

      let a = [...list.children];

      a.sort((a, b) => (a.dataset.name > b.dataset.name ? 1 : -1)).forEach(
        (node) => list.appendChild(node)
      );
    }
  };

  /**
   * Experts listing tab switcher
   */
  if (document.querySelectorAll(".experts-listing nav a").length > 0) {
    /**
     * Show all managing partners on load
     */
    document
      .querySelectorAll(".experts-listing .expert-box.sector-managing-partner")
      .forEach((box) => box.classList.remove("hidden"));
    document
      .querySelectorAll(".experts-listing nav a")
      .forEach((link) => link.classList.remove("active"));

    if (
      document.querySelector(
        '.experts-listing nav a[data-type="managing-partner"]'
      )
    )
      document
        .querySelector('.experts-listing nav a[data-type="managing-partner"]')
        .classList.add("active");

    /**
     * Order experts
     */
    order_experts();

    /**
     * Nav handler
     */
    document.querySelectorAll(".experts-listing nav a").forEach((link) => {
      /**
       * For each link add an event listnere to switch tabs
       */
      link.addEventListener("click", (e) => {
        /**
         * Get link target type
         */
        let type = e.target.dataset.type;

        /**
         * Change active
         */
        document
          .querySelectorAll(".experts-listing nav a")
          .forEach((link) => link.classList.remove("active"));
        e.target.classList.add("active");

        /**
         * Hide all boxes
         */
        document
          .querySelectorAll(".experts-listing .expert-box")
          .forEach((box) => {
            box.style.opacity = 0;
            box.classList.add("js-disabled");

            setTimeout(
              (box) => {
                box.style.display = "none";
              },
              200,
              box
            );
          });

        /**
         * Get target class
         */
        let cls = type == "partner" ? type : "sector-" + type;

        /**
         * Define selector
         */
        let selector = ".experts-listing .expert-box." + cls;

        /**
         * Show all related boxes
         */
        setTimeout(() => {
          document.querySelectorAll(selector).forEach((box) => {
            box.style.display = "grid";
            box.classList.remove("js-disabled");

            setTimeout(
              (box) => {
                box.style.opacity = 1;
              },
              200,
              box
            );
          });
        }, 200);
      });
    });
  }
}
